import axios from 'axios';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import { RenderHTMLSelect, RenderInputWithDiv, RenderSelect } from '../../../component/formInput';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

var _ = require('lodash');

class ChangeVPSTemplate extends React.Component {

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  submit(values) {
    const { onHide, reset, invoice_item_obj } = this.props;
    axios({
      method: 'post',
      url: window.api_url + '/admin/api/invoice/item/vps_template/modify',
      data: {
        invoice_item_id: invoice_item_obj.id,
        template_id: parseInt(values.template_id)
      },
      withCredentials: true
    }).then(function (response) {
       if(!response.data.isError) {
      reset();
        onHide();
       }
    })
  }
  

  handleHideModal = () => {
    const { onHide, reset } = this.props;
    reset();
    onHide();
  }

  render() {

    const { title, submitting, handleSubmit, userProduct, invoice_item_obj } = this.props;
    const modalConfig = { enforceFocus: false, backdrop: 'static', show: this.props.show, bssize: "medium", onHide: this.props.onHide, submitting: this.props.submitting };
    let { templates } = this.props;
    //vps 0, vps 1, vps pro 1 do not support windows
    if(invoice_item_obj.product.id == 375 || invoice_item_obj.product.id == 2 || invoice_item_obj.product.id == 398 ||invoice_item_obj.product.id == 399 ) {
      templates = _.filter(templates, (i) => i.is_linux );
    }
    const templates_option = _.map(templates, (i) => ({value:i.id, label: i.name + " " + i.version}));
    return ( 
      <Modal
        bsPrefix = "modal"
        {...modalConfig}
        dialogClassName="modal-open">
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-sm">Thay đổi VPS Template</Modal.Title>
          </Modal.Header>
          <form onSubmit={handleSubmit(this.submit)}>
            <Modal.Body>
              <Field name="template_id" label="VPS Template" options={templates_option} component={RenderHTMLSelect}></Field>
            </Modal.Body>
            <Modal.Footer>
              <div className="text-right">
                <a className="btn" onClick={this.handleHideModal}>Đóng</a>
                <button type="submit" className="btn bg-primary" disabled={submitting}>Cập nhật</button>
              </div>
            </Modal.Footer>
          </form>
      </Modal>
    )
  }
}
const mapState = (state,props) => ({
  initialValues : {
    template_id: props.invoice_item_obj.template_id
  }
});

const mapDispatch = dispatch => ({
  
});

export default (connect(mapState, mapDispatch)(
  reduxForm({
    form: 'ChangeVPSTemplate',
    destroyOnUnmount: true,
    enableReinitialize: true,
  })(withRouter(ChangeVPSTemplate))));
